module.exports = __webpack_public_path__ + "static/assets/396ed2335bc88ef065e6a3170b3e3b41.svg";